import { 
    BMC_SHENLONG_SERVICE_TYPES, 
    LOCALSESSIONDATAKEYS, 
    NATIVE_APP_SELECTION_ATTRIBUTE 
} from "../../constants/AppConstants";
import { 
    getNativeAppName,
    getNativeAppQueryParamsValuesByKey, 
    getShenlongQueryParams, 
    isBplusRegistrationProcess 
} from "../../constants/AppMethod";
import { getLocalSessionData, getUserDataByKey } from "../Authentication/handleUserSession";
import { getCountryCode } from "../Internationalization/handleAppInternationalization";
import { MSALInstance } from "../Authentication/Azure/MSALInstanceInit";

const NativeAppLogsPayload = ({
    isWebToApp = false, 
    isAppToWeb = false, 
    webToAppRequestURL = null, 
    isError = false, 
    errorPathname = null
}) => {
    const { params } = getShenlongQueryParams();
    const requestFrom = getNativeAppQueryParamsValuesByKey("request_from");
    const appName = getNativeAppName();
    const serviceTypeSelected = parseInt(getNativeAppQueryParamsValuesByKey("selection"));
    const IS_BPLUS_REGISTRATION_SERVICE = isBplusRegistrationProcess();
    const serviceName = (serviceTypeSelected === NATIVE_APP_SELECTION_ATTRIBUTE.BPLUS_SERVICE || IS_BPLUS_REGISTRATION_SERVICE)
    ? BMC_SHENLONG_SERVICE_TYPES.BPLUS : BMC_SHENLONG_SERVICE_TYPES.ECOPRO
    const serialNumber = getNativeAppQueryParamsValuesByKey("device_serial_no") || getLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER) || null;
    const deviceModel = getNativeAppQueryParamsValuesByKey("device_model") || getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL) || null;
    const ADB2CID = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);
    const currentAuthAccount = MSALInstance.getAllAccounts();
    const customerEmail = currentAuthAccount[0]?.idTokenClaims['signInNames.emailAddress'] 
                        || getUserDataByKey("emailAddress") || null
    const countryCode = getCountryCode();

    const getRequestURL = (isError, isAppToWeb, errorPathname, params, webToAppRequestURL) => {
        if (isError) return `[Error Occured] ${errorPathname}`;
        if (isAppToWeb) return params;
        return webToAppRequestURL;
    }
  
    return {
        "requestFrom": requestFrom,
        "appName": appName,
        "serviceName": serviceName,
        "deviceSerialNumber": serialNumber,
        "deviceModelNumber": deviceModel,
        "requestURL": getRequestURL(isError, isAppToWeb, errorPathname, params, webToAppRequestURL),
        "adB2CId": ADB2CID,
        "email": customerEmail,
        "countryCode": countryCode,
        "isWebToApp": isWebToApp,
        "isAppToWeb": isAppToWeb
    }
}

export default NativeAppLogsPayload;